import { Box, Container, Divider, Grid, Paper, TextField, Typography } from "@mui/material";
import CartItems from "./CartItems";

import globalContext from '../../context/context'
import { useContext } from "react";
import { useTranslation } from "react-i18next";

function CartSuccess() {

    const { contextData: { orderId } } = useContext(globalContext);
    const { t } = useTranslation();

    return (
        <>
            <Container disableGutters sx={{ pt: 4 }}>
                <Typography sx={{ fontSize: { xs: '24px', md: '32px' }, fontWeight: 300, textAlign: 'center', pb: 2 }}>{t('cart.successfulPaymentH1')}</Typography>

                <Box sx={{ mx: { xs: 0, md: '25%' } }}>
                    <Box sx={{ fontSize: 16, pb: 4, textAlign: 'center' }}>
                    {t('cart.successfulPaymentH2')}
                    </Box>
                    <CartItems />

                </Box>
            </Container>

        </>
    );
}

export default CartSuccess;
